import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import $ from "jquery";
import { loader_image } from "../_components/Imagepath";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {base_url, Apitoken, Authtoken  } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Select from "react-select";


const SoldesCabranes = () => {
  const [menu, setMenu] = useState(false);
  // const [data, setData] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [datacount, setDatacount] = useState({});
  const [permission, setPermission] = useState({});

  const [cabraneList, setCabraneList] = useState([]);
  const [paymentslists, setPaymentslists] = useState([]);
     let season_id = localStorage.getItem("season_id");

 const [formData, setFormData] = useState({
          season_id:season_id,
          start_date: '',
          end_date: '',
          name: ''
        });

  useEffect(() => {
        setPermission(FindModuleById(434)); 
      console.log(permission);
    axios.post(
        "/raw-materials/listing-cabanes-new",
        formData,
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        setDatacount(response.data.data.overview);
        setDataa(response.data.data.transports);
        setPaymentslists(response.data.data.payments);
      })
      .catch((error) => {
        console.log(error);
      });
  
    axios.post("/rawmaterials-cabranes/listing",{},{headers: { Authorization: `Bearer ${Authtoken}`,  Apitoken: Apitoken,},  } )
    .then((response) => {
      if (response.data.code === 200) {
        let suppliers = response.data.data.cabranes;
        let supplierslist = suppliers.map((cat, index) => ({
          label: cat.name,
          value: cat.id,
          text: `transport-${index}`,
        }));
        setCabraneList(supplierslist);
      } else {
        console.log("API response is not an array");
      }
    })  .catch((error) => {
      console.log(error);
    });


  }, []);


  const handleSelectChangeCustomer = (selectedOption) => {
    console.log(selectedOption);
    setFormData({ ...formData, name: selectedOption.value }); 
  };

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  
  

  const DriverCell = ({ row }) => (
    <a href={`/cabrane-situation-groupby/${row.original.cabrane_id}`} className="">
      {row.original.cabrane_name || ""}
    </a>
  );
  
  DriverCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        cabrane_id: PropTypes.number,
        cabrane_name: PropTypes.string,
      }),
    }),
  };
  
  const TotalAmountCell = ({ row }) => (
  <div>{Number(row.original.sum_final_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} dh</div>
  );
  
  TotalAmountCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        sum_final_amount: PropTypes.number,
      }),
    }),
  };
  
  const PaidAmountCell = ({ row }) => (
  <div>{Number(row.original.sum_final_payment_1_2).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} dh</div>
  );
  
  PaidAmountCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        sum_final_payment_1_2: PropTypes.number,
      }),
    }),
  };
  
  const OpenAmountCell = ({ row }) => (
  <div>{Number(row.original.situation).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} dh</div>
  );
  
  OpenAmountCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        situation: PropTypes.number,
      }),
    }),
  };
  
  const columnss = [
    {
      header: 'Cabrane',
      accessorKey: 'cabrane_name',
      Cell: DriverCell,
    },
    {
      accessorKey: 'number_of_receiption',
      header: 'No of Receiption',
    },
   
    {
      header: 'Total Amount',
      accessorKey: 'sum_final_amount', // Changed from accessorFn
      Cell: TotalAmountCell,
    },
    {
      header: 'Paid Amount',
      accessorKey: 'sum_final_payment_1_2', // Changed from accessorFn
      Cell: PaidAmountCell,
    },
    {
      header: 'Open Amount',
      accessorKey: 'situation', // Changed from accessorFn
      Cell: OpenAmountCell,
    },
  ];    
  


   const columnspayments =
   [
  
    {
      header: 'Cabrane',
      accessorFn: (row) => `${(row.cabranename)?row.cabranename.name:""} `,
    },
  
    {
      accessorKey: 'lot_number', //normal accessorKey
      header: 'Lot Number',
    },
 
 
    {
      accessorKey: 'shift_date', //normal accessorKey
      header: 'Shift Date',
    },
 
    {
      accessorKey: 'workers_cost', //normal accessorKey
      header: 'Worker Cost',
    },
    
   
     {
       accessorKey: 'origin', //normal accessorKey
       header: 'Origin',
     },
  
     {
      header: 'Supplier',
      accessorFn: (row) => `${(row.supplier_name)?row.supplier_name.name:""} `,
    },
    ];
 
 


  const downloadPDF = (e) => {
    console.log(e);
    $("#loader-image").removeClass('loader-hide').addClass('loader-show');

    axios.get("/raw-materials/listing-cabrane-pdf", {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        params: formData, // Use `params` for GET request data
    })
    .then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });

        // Try to get filename from content-disposition header
        const disposition = response.headers['content-disposition'];

         let file_name = 'Cabrane Situation '+datacount.start_date +' '+ datacount.end_date+ '.pdf';

        let fileName = file_name;

        if (disposition && disposition.includes('filename=')) {
            const match = disposition.match(/filename="?(.+)"?/);
            if (match.length > 1) fileName = match[1];
        }

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        $("#loader-image").removeClass('loader-show').addClass('loader-hide');
    })
    .catch(error => {
        console.error('Error downloading PDF:', error);
        $("#loader-image").removeClass('loader-show').addClass('loader-hide');
    });
};
function objectToQueryString(obj) {
  return Object.keys(obj)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
      .join('&');
}
  
      const downloadExcel = (e) => {
        console.log(e);
        const queryString = objectToQueryString(formData);
        $("#loader-image2").removeClass('loader-hide2');
        $("#loader-image2").addClass('loader-show2');
        window.open(`${base_url}/raw-materials/listing-cabrane-global-situation-excel?${queryString}`, '_blank');
        $("#loader-image2").addClass('loader-hide2');
        $("#loader-image2").removeClass('loader-show2');
      }
  
 
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
      
      
       
      
   const handleSubmit = (e) => {

    e.preventDefault();
    console.log("formData2");
    console.log(formData);

    axios.post(
      "/raw-materials/listing-cabanes-new",
      formData,
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        params: formData, // Use `params` for GET request data
      }
    )
    .then((response) => {
      setDatacount(response.data.data.overview);
      setDataa(response.data.data.transports);
      setPaymentslists(response.data.data.payments);
    })
    .catch((error) => {
      console.log(error);
    });

  
  
   }
   const customHandleInput = (event) => {
     const Input_name = event.target.name;
       console.log(Input_name);   
   };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Cabrane Situation</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">Cabrane Situation Listing</li>
                  </ul>
                </div>
               
              </div>
            </div>
            <div id="filter_inputs_div" className="card filter-card1">
              <div className="card-body p-10">
                <form onSubmit={handleSubmit}>
                <div className="row">
                <div className="col-md-3">
                    <div className="form-group">
                      <label>Select Cabrane:</label>
                   
                        <Select
                          options={cabraneList}
                          name="name"
                          value={cabraneList.find(option => option.value === formData.name) || null} // Ensure it selects the correct option
                          onChange={(selectedOption) => handleSelectChangeCustomer(selectedOption)}
                         
                                      
                                      />
                    </div>
                  </div>        
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Start Date:</label>

                      <input type="hidden" name="supplier" className="form-control"  value={formData.transport}   />

                      <input type="date" name="start_date" className="form-control"  value={formData.start_date} onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}  />
                    </div>
                  </div>
                
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>End Date:</label>
                      <input type="date" name="end_date" className="form-control"  value={formData.end_date} onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}  />
                    </div>
                  </div>
                
                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                      &nbsp;&nbsp;
                      <a href="/cabrane-situation" className="btn btn-primary me-1"><i className="fa fa-times"></i></a>

                    </div>
                  </div>
                </div>
                </form>
                
              </div>
              </div>
     
            <div className="row">
                
              <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                <div className="card inovices-card w-100">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <div className="dash-count">
                        <div className="dash-title"> Total Transport  Cost </div>
                        <div className="dash-counts">
                          <p>{datacount.tab_total_amount}dh</p>
                        </div>
                      </div>
                    </div>
                  
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                <div className="card inovices-card w-100">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <div className="dash-count">
                        <div className="dash-title"> Total Payment</div>
                        <div className="dash-counts">
                        <p>{datacount.tab_paid_amount}dh</p>
                        </div>
                      </div>
                    </div>
                  
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                <div className="card inovices-card w-100">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <div className="dash-count">
                        <div className="dash-title"> Open Amount</div>
                        <div className="dash-counts"> <p>{datacount.tab_open_amount}dh</p>
                        </div>

                      </div>
                    </div>
                  
                  </div>
                </div>
              </div>
                    
              </div>
           
          
            <div className="row">
               <div className="col-sm-12" >
              <section className="comp-section">
              
              <div className="row">
              <div className="col-md-12">
                {permission && permission.list == 1 && (
              <div className="col-auto" style={{float:'right', paddingBottom:'30px'}}>
                      <button
                        className="btn btn-primary"
                        onClick={() => downloadPDF()}
                      >
                        <i className="fas fa-file-pdf font-24" ></i>  <img id="loader-image" className="loader-image loader-hide" src={loader_image}/> 
                      </button>  
                      &nbsp;&nbsp;
                      <button
                        className="btn btn-primary"
                        onClick={() => downloadExcel()}
                      >
                        <i className="fas fa-file-excel	font-24"></i> <img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image}/>
                      </button>   
              </div>
                )}
              </div>
              <div className="col-md-12">
                    {permission && permission.list == 1 && (
                         <div className="card bg-white">
                                                 
                            <div className="card-body">
                                <ul className="nav nav-tabs nav-tabs-bottom">
                                
                              
                                <li className="nav-item">
                                    <a className="nav-link active" href="#listing-groupby-transport" data-bs-toggle="tab">Group By Cabrane</a>                                  
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link " href="#listing-all" data-bs-toggle="tab"> Raw Material Cabrane</a>                                   
                                </li>  
                                                  
                                </ul>
                                <div className="tab-content">
                              
                                <div className="tab-pane show active" id="listing-groupby-transport">
                                <div className="row"   id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                          <div className="table-responsive">

                                          <MaterialReactTable columns={columnss} data={dataa} 
                                            enableColumnOrdering
                                            enableColumnFilterModes
                                            enablePinning
                                          />
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                  
                                  </div>                                
                                  <div className="tab-pane  " id="listing-all">
                                    <div className="row"   id="listing-followup">
                                      <div className="col-sm-12">
                                        <div className="card card-table">
                                          <div className="card-body">
                                              <div className="table-responsive">
                                              <MaterialReactTable columns={columnspayments} data={paymentslists} 
                                                    enableColumnFilterModes
                                                    enableColumnOrdering
                                                    // enableGrouping
                                                    enablePinning
                                                  
                                                  />
                                              
                                              </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  
                                  </div>                                
                                                        
                                
                                </div>                             
                            </div>
                            </div>
                       )}
                    </div>
                    </div>
                </section>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
};
export default SoldesCabranes;
